var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#325E89;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#325E89;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230,189.4l-22.9-22.9c-3.7-3.7-8.8-5.8-14-5.8c-5.2,0-10.3,2.1-14,5.8l-5.2,5.2l-37.1-37.1l5.2-5.2 c7.7-7.8,7.7-20.3,0-28L119,78.4c-7.7-7.7-20.3-7.7-28,0l-3.2,3.1c-9.7,9.7-15.1,22.7-15.1,36.4c0,13.6,5.4,26.7,15.1,36.4 l66.2,66.2c9.6,9.7,22.7,15.1,36.3,15.1c2.1,0,4.2-0.1,6.3-0.4c11.4-1.3,22.1-6.5,30.2-14.7l3.2-3.1 C237.7,209.6,237.7,197.1,230,189.4z M225.6,212.9l-3.2,3.2c-8.5,8.5-20,13.2-31.9,13.2s-23.5-4.8-31.9-13.2l-66.2-66.2 c-8.5-8.5-13.2-20-13.2-31.9c0-12,4.8-23.5,13.2-31.9l3.1-3.2c2.5-2.5,6-4,9.6-3.9c3.6,0,7,1.4,9.6,3.9l22.9,22.9 c5.3,5.3,5.3,13.8,0,19.1l-7.4,7.4c-1.2,1.2-1.2,3.2,0,4.5l41.6,41.6c1.2,1.2,3.2,1.2,4.5,0l7.4-7.4c2.5-2.6,6-4,9.6-4 c3.6,0,7,1.4,9.6,4l22.9,22.9C230.8,199.1,230.8,207.7,225.6,212.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone2);
export default __webpack_public_path__ + "static/media/phone2.a42cefabcfd27094ed5db2dcea4d3dcf.svg";
export { ForwardRef as ReactComponent };